/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrgDynamicPermission } from './OrgDynamicPermission';
import {
    OrgDynamicPermissionFromJSON,
    OrgDynamicPermissionFromJSONTyped,
    OrgDynamicPermissionToJSON,
    OrgDynamicPermissionToJSONTyped,
} from './OrgDynamicPermission';

/**
 * 
 * @export
 * @interface GetOrganizationDynamicPermissions200Response
 */
export interface GetOrganizationDynamicPermissions200Response {
    /**
     * 
     */
    data?: Array<OrgDynamicPermission>;
}

/**
 * Check if a given object implements the GetOrganizationDynamicPermissions200Response interface.
 */
export function instanceOfGetOrganizationDynamicPermissions200Response(value: object): value is GetOrganizationDynamicPermissions200Response {
    return true;
}

export function GetOrganizationDynamicPermissions200ResponseFromJSON(json: any): GetOrganizationDynamicPermissions200Response {
    return GetOrganizationDynamicPermissions200ResponseFromJSONTyped(json, false);
}

export function GetOrganizationDynamicPermissions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationDynamicPermissions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(OrgDynamicPermissionFromJSON)),
    };
}

export function GetOrganizationDynamicPermissions200ResponseToJSON(json: any): GetOrganizationDynamicPermissions200Response {
    return GetOrganizationDynamicPermissions200ResponseToJSONTyped(json, false);
}

export function GetOrganizationDynamicPermissions200ResponseToJSONTyped(value?: GetOrganizationDynamicPermissions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(OrgDynamicPermissionToJSON)),
    };
}

